import { ReactComponent as AnalysisIcon } from '@platform/assets/icons/analysis.svg';
import { ReactComponent as BookIcon } from '@platform/assets/icons/book.svg';
import { ReactComponent as CalendarIcon } from '@platform/assets/icons/calendar.svg';
import { ReactComponent as ChallengeIcon } from '@platform/assets/icons/challenge.svg';
import { ReactComponent as DashboardIcon } from '@platform/assets/icons/dashboard.svg';
import { ReactComponent as FireIcon } from '@platform/assets/icons/fire.svg';
import { ReactComponent as JournalIcon } from '@platform/assets/icons/journal.svg';
import { ReactComponent as ShowcaseIcon } from '@platform/assets/icons/showcase.svg';
import { ReactComponent as TrackIcon } from '@platform/assets/icons/track.svg';
import { ReactComponent as MenuItemsIcon } from '@platform/assets/icons/menu-items.svg';
import { PLATFORM_ROUTES } from './routes';

export const SIDEBAR_ITEMS: {
    id: string;
    icon: JSX.Element;
    path: string;
    name: string;
}[] = [
        {
            id: 'dashboard',
            icon: <DashboardIcon />,
            path: PLATFORM_ROUTES.home,
            name: 'Dashboard',
        },
        {
            id: 'skills',
            icon: <BookIcon />,
            path: PLATFORM_ROUTES.skills,
            name: 'Skills',
        },
        {
            id: 'tracks',
            icon: <TrackIcon />,
            path: PLATFORM_ROUTES.tracks,
            name: 'Tracks',
        },
        {
            id: 'resources',
            icon: <MenuItemsIcon />,
            path: PLATFORM_ROUTES.resources,
            name: 'Resources',
        },
        {
            id: 'events',
            icon: <CalendarIcon />,
            path: PLATFORM_ROUTES.events,
            name: 'Events',
        },
        {
            id: 'analysis',
            icon: <AnalysisIcon />,
            path: PLATFORM_ROUTES.analysis,
            name: 'Analysis',
        },
        {
            id: 'challenges',
            icon: <ChallengeIcon />,
            path: PLATFORM_ROUTES.challenges,
            name: 'Challenges',
        },
        {
            id: 'showcase',
            icon: <ShowcaseIcon />,
            path: PLATFORM_ROUTES.showcase,
            name: 'Showcase',
        },
        {
            id: 'rewards',
            icon: <FireIcon />,
            path: PLATFORM_ROUTES.rewards,
            name: 'Rewards',
        },
        {
            id: 'journal',
            icon: <JournalIcon />,
            path: PLATFORM_ROUTES.journal,
            name: 'Journal',
        },
    ];
